export const hashtageData = [
  '☕️ 커피가 맛있는',
  '✨ 분위기가 좋은',
  '📸 사진찍기 좋은',
  '🍰 디저트가 맛있는',
  '📔 집중하기 좋은',
  '👫 모임하기 좋은'
];
